import React from 'react';

export default {
  width: 16,
  height: 16,
  content: (
    <>
      <path
        d="M10.108 11.554l-3.273 3.273a4.005 4.005 0 0 1-5.663-5.662L4.446 5.89l.944.944-3.274 3.273a2.674 2.674 0 0 0 0 3.775 2.673 2.673 0 0 0 3.775 0l3.274-3.273.943.944zM9.164 1.173L5.863 4.475l.944.944 3.302-3.303a2.673 2.673 0 0 1 3.775 0 2.672 2.672 0 0 1 0 3.775L10.58 9.194l.945.944 3.303-3.303a4.006 4.006 0 0 0 0-5.663 4.006 4.006 0 0 0-5.663 0zM10.53 6.53l-4 4-1.06-1.06 4-4 1.06 1.06z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </>
  )
};
